import React, { useCallback, useMemo } from "react";

import LicenseColumnFilterDropdown from "./LicenseColumnFilterDropdown";

import { LICENSE_STATUS_FILTER } from "../../../../constants/LicenseManagement.constants";

const LicenseStatusHeaderRenderer = ({
  displayName,
  onFilterClick,
  licenseId,
  currentFilters = [],
  showFilterIcon = true,
  id,
  licenseType,
  licenseName,
}) => {
  const currentLicenseFilter = useMemo(
    () => currentFilters.find((filter) => filter.licenseId === licenseId),
    [currentFilters, licenseId],
  );

  const selectedStatuses = useMemo(() => {
    if (!currentLicenseFilter) return [];

    const { isActive, isExpiringSoon, isExpired, isTerminated, isUnassigned } =
      currentLicenseFilter;

    return [
      isActive && "active",
      isExpiringSoon && "expiringSoon",
      isExpired && "expired",
      isTerminated && "terminated",
      isUnassigned && "unassigned",
    ].filter(Boolean);
  }, [currentLicenseFilter]);

  const isFiltered = selectedStatuses.length > 0;

  const handleFilterChange = useCallback(
    (selectedStatuses) => {
      const allExistingFilters = currentFilters || [];

      const currentLicenseFilterData = {
        licenseId,
        isActive: selectedStatuses.includes("active"),
        isExpiringSoon: selectedStatuses.includes("expiringSoon"),
        isExpired: selectedStatuses.includes("expired"),
        isTerminated: selectedStatuses.includes("terminated"),
        isUnassigned: selectedStatuses.includes("unassigned"),
      };

      const filtersWithoutCurrentLicense = allExistingFilters.filter(
        (filter) => filter.licenseId !== licenseId,
      );

      const updatedFiltersArray =
        selectedStatuses.length > 0
          ? [...filtersWithoutCurrentLicense, currentLicenseFilterData]
          : filtersWithoutCurrentLicense;

      onFilterClick?.(updatedFiltersArray);
    },
    [currentFilters, licenseId, onFilterClick],
  );

  return (
    <LicenseColumnFilterDropdown
      displayName={displayName}
      options={LICENSE_STATUS_FILTER}
      selectedValues={selectedStatuses}
      onFilterChange={handleFilterChange}
      multiSelect
      closeOnChange
      className="license-status-header-renderer"
      dropdownClassName="license-status-filter-portal-dropdown"
      showFilterIcon={showFilterIcon}
      isFiltered={isFiltered}
      id={id}
      title={`${licenseType} - ${licenseName}`}
    />
  );
};

export default LicenseStatusHeaderRenderer;
